import { defineStore } from "pinia";
import axios from "axios";
export const ladies = defineStore("ladies", {
  state: () => ({
    datawoman: [],
    electronics: [],
    tv: [],
    womData: [],
  }),
  actions: {
    async getdataWoman() {
      await axios.get("https://fakestoreapi.com/products").then((res) => {
        this.datawoman = res.data.filter((el) => {
          return el.category === "women's clothing";
        });
        this.datawoman.forEach((e) => {
          e.wishlist = false;
        });
        this.electronics = res.data.filter((el) => {
          return el.category === "electronics";
        });
        this.electronics.forEach((e) => {
          e.wishlist = false;
        });
        this.tv = res.data.filter((el) => {
          return el.id === 13 || el.id === 14;
        });
        this.tv.forEach((e) => {
          e.wishlist = false;
        });
      });
    },
    async getSinglePro(productId) {
      await axios
        .get(`https://fakestoreapi.com/products/${productId}`)
        .then((res) => {
          console.log(res.data);
          this.womData = res.data;
          this.womData.wishlist = false;
        });
    },
  },
});
